
const createHomeStyles = (props) => {
  const width1 = props.small ? '160px' : '260px'
  return {
    videoCell: { padding: '2px', margin:'8px', width: '260px', minWidth: '260px', cursor: props.isThisTheActiveVideo ? 'default' : 'pointer' },
    videoCell2: { marginBottom: '10px', fontSize: '16px', cursor: props.isThisTheActiveVideo ? 'default' : 'pointer' },
    iconPlay: {
      width: '24px',
      height: '24px',
      marginLeft: '8px',
    },
    isPlaying: {
      padding: '8px',
      color: 'white',
      backgroundColor: 'red',
    },
    videoTitle: {
      width: width1,
      padding: '4px',
      textAlign: 'left',
      overflow: 'hidden',
      wordBreak: 'break-all',
      paddingRight: '16px',
      marginRight: '16px',
      fontSize: '14px',
    },
    videoInCell: {
      width: width1,
      minWidth: width1,
      aspectRatio: '16/9',
      overflow: 'hidden',
      // position: 'relative',
    },

    cellButtons: {
      position: 'absolute',
      bottom: '0px',
      left: '0px',
      zIndex: 2,
      color: '#fff',
      '& button': {
        paddingLeft: '0',
      },
    },
  }
}

export default createHomeStyles
